/* eslint no-use-before-define: 0 */
import jQuery from "jquery";

(function main($) {
    $(document).ready(() => {
        const $leftNav = $(".feature-navigation");
        const $collapser = $(".collapser");
        const $selectedLink = $leftNav.find("a.selected").first();

        const openClass = "open";
        const showClass = "show";

        if ($selectedLink.length) {
            if ($selectedLink.hasClass("feature-navigation__level-one")) {
                setTimeout(function () { $selectedLink.next(".collapser").click(); }, 10);
            }
            if ($selectedLink.hasClass("feature-navigation__level-two")) {
                setTimeout(function() {
                    $selectedLink.parents(".child-pages").prev(".collapser").click();

                    if ($selectedLink.next(".collapser").length) $selectedLink.next(".collapser").click();
                }, 10);
            }
        }

        $collapser.click(function () {
            $(this).toggleClass(openClass);
            $(this).next().toggleClass(showClass);
        });
    });
}(jQuery));
